module.exports = __webpack_public_path__ + "img/navigation.bbefa253.svg";